import React from 'react';
import type { AmendatoryLineItemProps } from '../AmendatoryCoverageLineItemFactory';
import CoverageOptionsWrapper from '../shared/CoverageItemsWrapper';
import CoverageButton from '../shared/CoverageButton';
import type { SEFormValues } from '../../../../../../../../primeX-underwriter/modals/coverageLineItemModals/SpecifiedEventExclusionModal';
import { SpecifiedEventExclusionModalConfig } from '../../../../../../../../primeX-underwriter/modals/coverageLineItemModals/SpecifiedEventExclusionModal';
import { Modal } from '../../../../../../../../../../components/modals/v2/helpers/v2.modal.helpers';
import type { SE } from '../../../../../../api/types/rater-x-preset';

const SpecifiedEventExclusion = (props: AmendatoryLineItemProps) => {
  const handleAddSE = (formValues: SEFormValues) => {
    const _exclusions = formatSEForState(formValues);

    props.setCoverage({
      id: props.id,
      value: {
        props: {
          exclusions: { values: _exclusions as unknown as SE[] },
        },
      },
    });
  };

  return (
    <CoverageOptionsWrapper>
      <CoverageButton
        disabled={!props.isSelected}
        onClick={Modal.deferShow(SpecifiedEventExclusionModalConfig, {
          data: {
            onSubmit: handleAddSE,
            exclusions: getDefaultSEValues(
              props.value?.props?.exclusions?.values as SE[]
            ),
          },
        })}
      >
        Add/Edit ({String(props.value?.props?.exclusions?.values?.length ?? 0)})
      </CoverageButton>
    </CoverageOptionsWrapper>
  );
};

export default SpecifiedEventExclusion;

export function getDefaultSEValues(values: SE[] | undefined) {
  if (!values) {
    return [];
  }

  return values.map((value) => {
    return {
      claimDate: value.props.date.value ?? '',
      claimDescription: value.props.description?.value ?? '',
      claimName: value.props.name.value ?? '',
      claimNumber: value.props.number.value ?? '',
    };
  });
}

export function formatSEForState(formValues: SEFormValues) {
  return formValues.exclusions.map((exclusion) => {
    return {
      props: Object.keys(exclusion).reduce((acc, key) => {
        const value = exclusion[key as keyof typeof exclusion];
        const _key = EventNameMapping[key as keyof typeof EventNameMapping];
        return {
          ...acc,
          [_key]: { value },
        };
      }, {} as SE),
    };
  });
}

const EventNameMapping = {
  claimDate: 'date',
  claimDescription: 'description',
  claimName: 'name',
  claimNumber: 'number',
};
